import {Animatable, Animation} from "../../../feature/project/Shot";
import React, {CSSProperties, ReactNode, useEffect, useRef} from "react";
import {interpolators} from "../../common/Interpolators";
import {animationToTransformFrom, animationToTransformTo} from "../../common/Animation";
import {Simulate} from "react-dom/test-utils";
import play = Simulate.play;


export const AnimatableElement = (props: {
    style?: CSSProperties,
    animationStyle?: CSSProperties,
    element: Animatable,
    play: boolean,
    scale: number,
    animations: Array<Animation>,
    children: ReactNode | null | undefined | string,
    onPlayEnd: (id: number) => void,
    onMouseDown?: (e: any) => void,
}) => {
    useEffect(() => {
        if (props.animations.length == 0 && props.play) {
            props.onPlayEnd(props.element?.id ?? 0)
        }
    }, [props.play])

    return (
        <div
            onMouseDown={props.onMouseDown}
            className={'animatable-element'}
            style={props.style ? props.style : {
                position: 'absolute',
                zIndex: props.element.z === 0 ? 1 : props.element.z,
                top: (props.element.y || 0),
                left: (props.element.x || 0),
                transform: `scale(${props.scale})`,
            }}
        >
            {props.play && props.animations.length > 0 ?
                <style>
                    {props.animations.map((animation) => `
                .animation-${animation.id} {
                    animation: ${animation.duration != null ? `${animation.duration + (animation.repeatDelay || 0)}ms` : ''} ${interpolators.find(item => item.key === animation.interpolator)?.value || 'ease'} ${animation.startDelay != null ? `${animation.startDelay}ms` : ''} ${animation.repeat != null ? (animation.repeat > 0 ? `${animation.repeat}` : 'infinite') : ''} ${animation.reverse ? 'alternate' : ''} forwards animation-${animation.id};
                    ${animation.pivotX != null || animation.pivotY != null ? `transform-origin: ${animation.pivotX != null ? `${animation.pivotX}px` : '0px'} ${animation.pivotY != null ? `${animation.pivotY}px` : '0px'}` : ''};
                }
                @keyframes animation-${animation.id} {
               
               
                ${animation.repeatDelay != undefined && animation.repeatDelay > 0 ? (animation.repeatDelay || 0) / ((animation.duration || 0) + (animation.repeatDelay || 0)) * 100 : 0}% {
                    ${animationToTransformFrom(animation).trim() ? `transform: ${animationToTransformFrom(animation)};` : ``}
                    ${animation.alphaFrom != null ? `opacity: ${animation.alphaFrom / 100};` : ``}
                }
                100% {
                    ${animationToTransformTo(animation).trim() ? `transform: ${animationToTransformTo(animation)};` : ``}
                    ${animation.alphaTo != null ? `opacity: ${animation.alphaTo / 100};` : ``}
                } 
            }`).join('\n')}
                </style> : ''}
            <AnimatableElementContainer animationStyle={props.animationStyle} onPlayEnd={props.onPlayEnd} animations={props.animations}>
                {props.children}
            </AnimatableElementContainer>
        </div>
    )
}

export const AnimatableElementContainer = (props: {
    onPlayEnd: (id: number) => void,
    animations: Array<Animation>,
    children: string | ReactNode | null,
    animationStyle?: CSSProperties,
}) => {

    return (
        props.animations.length > 0 ?
            <div style={{...props.animationStyle, position: 'absolute'}}
                 className={`animation-${props.animations[0].id}`}
                 onAnimationEnd={(e) => {
                     props.onPlayEnd(props.animations[0].id ?? 0)
                 }}
            >
                <AnimatableElementContainer onPlayEnd={props.onPlayEnd} animations={props.animations.slice(1)}>
                    {props.children}
                </AnimatableElementContainer>
            </div> :
            <>{props.children}</>
    )
}